export default (theme) => ({
  subNav: {
    flexDirection: "column",
    marginBottom: 50,
    marginTop: 40,
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
    },
    "& a": {
      fontFamily: theme.headerFont,
      color: theme.palette.secondary.contrastText,
      textDecoration: "none",
      textTransform: "uppercase",
      fontWeight: "600",
      letterSpacing: "0.04em",
      margin: "0 20px",
      fontSize: 18,
      lineHeight: 1.5,
      padding: "0 0 30px",
      // flex: '0 0 100%',
      width: "100%",
      transition: "color .3s ease-in-out",
      "&:hover, &:focus": {
        color: theme.palette.primary.main,
      },
    },
  },
});
